import axios from 'axios';

// search roles api
export async function searchAccessTypesAPI(Data) {
	let accessTypeslist = [];
	const accessTypeName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/accessTypes/search/?accessTypeName=${accessTypeName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		accessTypeslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return accessTypeslist;
}

// check existing access type api
export async function getAccessTypeNameAPI(Data) {
	let accessTypeslist = [];
	const accessTypeName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/accessTypes/getAccessTypeName/?accessTypeName=${accessTypeName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		accessTypeslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return accessTypeslist;
}

//create access types api
export async function createAccessTypesAPI(Data, userID) {
	let accessTypesData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}system/accessTypes/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		accessTypesData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return accessTypesData;
}

//update roles api
export async function updateAccessTypesAPI(Data, accessTypeCode, userID) {
	let accessTypesData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/accessTypes/update/?accessTypeCode=${accessTypeCode}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		accessTypesData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return accessTypesData;
}